import React from 'react';
import type { PreviewColorScheme } from '../WebsitePreview';

const EcommercePreview: React.FC<{ scheme: PreviewColorScheme }> = ({ scheme }) => (
  <div style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: '12px' }}>
    {/* Nav */}
    <nav
      style={{ backgroundColor: scheme.surface, borderBottom: `1px solid ${scheme.border}`, padding: '10px 20px' }}
      className="flex items-center justify-between"
    >
      <div style={{ color: scheme.text, fontWeight: 700, fontSize: '14px' }}>Sample store</div>
      <div className="flex gap-4 items-center">
        {['New', 'Sale', 'Collections'].map(t => (
          <span key={t} style={{ color: scheme.textMuted, fontSize: '11px' }}>{t}</span>
        ))}
        <div style={{ backgroundColor: scheme.primary, color: '#fff', width: '22px', height: '22px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700 }}>
          3
        </div>
      </div>
    </nav>

    {/* Hero Banner */}
    <div style={{ padding: '24px 20px', background: `linear-gradient(135deg, ${scheme.primary}, ${scheme.secondary})`, textAlign: 'center' }}>
      <div style={{ color: '#fff', fontWeight: 800, fontSize: '18px', marginBottom: '4px' }}>Spring Collection</div>
      <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '11px', marginBottom: '10px' }}>Example collection banner</div>
      <span style={{ backgroundColor: '#fff', color: scheme.primary, padding: '6px 16px', borderRadius: '5px', fontWeight: 600, fontSize: '11px' }}>
        Shop Now
      </span>
    </div>

    {/* Product Grid */}
    <div style={{ padding: '16px 20px' }}>
      <div style={{ color: scheme.text, fontWeight: 700, fontSize: '13px', marginBottom: '10px' }}>Sample products</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
        {[
          { name: 'Classic Tee', price: '$29', badge: null },
          { name: 'Slim Joggers', price: '$59', badge: 'New' },
          { name: 'Canvas Bag', price: '$45', badge: 'Sale' },
        ].map(p => (
          <div key={p.name} style={{ backgroundColor: scheme.surface, border: `1px solid ${scheme.border}`, borderRadius: '8px', overflow: 'hidden' }}>
            <div style={{ height: '70px', backgroundColor: `${scheme.secondary}10`, position: 'relative' }}>
              {p.badge && (
                <span style={{
                  position: 'absolute', top: '4px', left: '4px',
                  backgroundColor: p.badge === 'Sale' ? scheme.secondary : scheme.primary,
                  color: '#fff', fontSize: '8px', fontWeight: 700, padding: '1px 5px', borderRadius: '3px',
                }}>
                  {p.badge}
                </span>
              )}
            </div>
            <div style={{ padding: '8px' }}>
              <div style={{ color: scheme.text, fontWeight: 600, fontSize: '11px' }}>{p.name}</div>
              <div className="flex items-center justify-between" style={{ marginTop: '4px' }}>
                <span style={{ color: scheme.primary, fontWeight: 700 }}>{p.price}</span>
                <span style={{ backgroundColor: scheme.primary, color: '#fff', fontSize: '9px', padding: '2px 6px', borderRadius: '3px', fontWeight: 600 }}>
                  Add
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default EcommercePreview;
